import React from 'react'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

import {
    GridContainer,
    GridItem11xs12,
    GridItem12,
} from '../../../business-components/Grid/Grid'

 import {
    CardGridEstudo,
} from '../../../business-components/Card/Card'

import {
    CardGridEstudoTabelaPadrao,
} from '../estudo-form/EstudoComp'

import CaptacaoLeadsFormInclusao from './CaptacaoLeadsFormInclusao'



const CaptacaoLeadsForm = ( { variaveisGlobais, values, handleChange, handleSubmit, setFieldValue,
    handleSubmitAutomatico, vars, /*linhaTipoLicenca,*/ /*idConfiguracao, *//*jsonConfiguracao,
        jsonUsuario, jsonUsuarioAdmin,*/linhaFormList, jsonIntegracao, arquivoList,
            obterArquivoList } ) => {

    const CardGridEstudoAux = values.modoApresentacao ? GridItem12 : CardGridEstudo
    


    return (
        <GridContainer
            className='justify-center'
        >
            <GridItem11xs12>
                <CardGridEstudoAux>
                    <CardGridEstudoTabelaPadrao
                        values={values}
                        SvgIcon={''}
                        label={
                            jsonIntegracao.tipoLinkCaptacaoLeads === HARDCODE.tipoLinkCaptacaoLeadsConsorcio
                                ?
                                    LABEL.integracaoInclusaoSiteInstitucionalCaptacaoLeadsConsorcio
                                :
                                    jsonIntegracao.tipoLinkCaptacaoLeads === HARDCODE.tipoLinkCaptacaoLeadsQuestionario
                                        ?
                                            LABEL.integracaoInclusaoSiteInstitucionalCaptacaoLeadsQuestionario
                                        :
                                            LABEL.integracaoInclusaoSiteInstitucionalCaptacaoLeadsDiagnosticoAposentadoria
                        }
                        helpTextMorte={''}
                        helpTextInvalidez={''}
                        component={
                            <CaptacaoLeadsFormInclusao
                                variaveisGlobais={variaveisGlobais}
                                values={values}
                                handleChange={handleChange}
                                handleSubmit={handleSubmit}
                                setFieldValue={setFieldValue}
                                handleSubmitAutomatico={handleSubmitAutomatico}
                                vars={vars}
                                //linhaTipoLicenca={vars.linhaTipoLicenca}
                                //idConfiguracao={idConfiguracao}
                                //jsonConfiguracao={vars.jsonConfiguracao}
                                //jsonUsuario={vars.jsonUsuario}
                                //jsonUsuarioAdmin={vars.jsonUsuarioAdmin}
                                linhaFormList={linhaFormList}
                                jsonIntegracao={jsonIntegracao}
                                arquivoList={arquivoList}
                                obterArquivoList={obterArquivoList}
                            />
                        }
                        popup={false}
                    />
                </CardGridEstudoAux>
            </GridItem11xs12>
        </GridContainer>
    )
}

export default CaptacaoLeadsForm